const DELIMITERS = [" ", ","];
const UNDO = "Escape";

const DELIMITERS_SPLIT_REPLACE_REGEX = new RegExp(
  `[${DELIMITERS.join("")}]+`,
  "g",
);
const DELIMITERS_CHECK_REGEX = new RegExp(`[${DELIMITERS.join("")}]`);

export const getEditValue = (value: string | undefined): string | undefined => {
  return value?.replace(DELIMITERS_SPLIT_REPLACE_REGEX, "").trim();
};

export const splitEmails = (emails: string): string[] => {
  return emails.split(DELIMITERS_SPLIT_REPLACE_REGEX);
};

export const shouldFlushEmailForEventKey = (eventKey: string) => {
  return DELIMITERS.includes(eventKey) || eventKey === "Enter";
};

export const shouldUndoForEventKey = (eventKey: string) => {
  return eventKey === UNDO;
};

export const hasDelimiters = (value: string) => {
  return DELIMITERS_CHECK_REGEX.test(value);
};
